import { HOME_PAGE } from 'Rentlio/utils/routes'

// Builds the booking-engine "home" URL used by the header logo link. It keeps the deeplink
// unit/rate context plus the two session-scoped attribution params (Google Travel flag and
// reference code), so a guest who arrived from Google Travel or with a reference code stays
// attributed after the full page reload — on reload the frontend Search re-captures both from the
// URL. Without them here the logo click lands on a plain home URL and the attribution is lost.
export default function buildHomepageUrl({
  locale,
  unitTypeId,
  ratePlanId,
  bookingEngineId,
  fromGoogleTravel,
  referenceCode
}) {
  let homePageUrl = `${HOME_PAGE}?language=${locale}`

  if (unitTypeId !== null) {
    homePageUrl += `&unitTypeId=${unitTypeId}`
  }

  if (ratePlanId !== null) {
    homePageUrl += `&ratePlanId=${ratePlanId}`
  }

  if (bookingEngineId !== null) {
    homePageUrl += `&bookingEngineId=${bookingEngineId}`
  }

  if (fromGoogleTravel) {
    homePageUrl += `&fromGoogleTravel=1`
  }

  if (referenceCode) {
    homePageUrl += `&referencecode=${referenceCode}`
  }

  return homePageUrl
}
